<template>
    <div class="product-select-bidding">
        <BiddingPriceData :list-price="listPrice" class="product-select-bidding__price-data">
            <template #middle>
                <div class="product-select-bidding__variant-data ml-auto text-right">
                    {{ variantDurationAndContingent }}
                </div>

                <p>
                    {{ $t('ProductSelect.bidding.wishText') }}
                </p>
            </template>
        </BiddingPriceData>

        <BiddingControls
            :price-hints="priceHints"
            @change="bidAmount = $event"
            class="product-select-bidding__controls"
        />

        <div class="product-select-bidding__submit-wrapper">
            <BiddingCheckoutLink
                :product-variant-id="selectedVariant.id"
                :bid-amount="bidAmount"
                class="product-select-bidding__submit-button"
            />
        </div>
    </div>
</template>

<script>
import DetailsSection from '@/components/DetailsSection.vue';
import PriceNew from '@/components/PriceNew.vue';
import BiddingControls from '@/components/product/auction/BiddingControls.vue';
import Price from '@/components/Price.vue';
import SectionRowJustified from '@/components/SectionRowJustified.vue';
import BiddingPriceData from '@/components/product/auction/BiddingPriceData.vue';
import BiddingCheckoutLink from '@/components/product/auction/BiddingCheckoutLink.vue';

export default {
    name: 'ProductSelectBiddingBody',
    components: {
        BiddingCheckoutLink,
        BiddingPriceData,
        SectionRowJustified,
        Price,
        BiddingControls,
        PriceNew,
        DetailsSection
    },

    data() {
        return {
            bidAmount: null
        };
    },

    props: {
        selectedVariant: {
            type: Object,
            required: true
        }
    },

    computed: {
        priceHints() {
            return this.selectedVariant && this.selectedVariant.priceHints;
        },

        listPrice() {
            return this.$getSafe(this.selectedVariant, 'price.regularPriceValues.listPrice');
        },

        variantDurationAndContingent() {
            const { duration, persons } = this.selectedVariant;
            return `${duration}, ${persons}`;
        },

        checkoutLink() {
            return {
                name: 'checkout',
                query: {
                    productVariantId: this.selectedVariant.id,
                    bidAmount: this.bidAmount,
                    mobileTeaser: true // TODO: clear up if we show for all products on mobile
                }
            };
        }
    }
};
</script>

<style scoped lang="scss">
@use '@/styles/mixins';

.product-select-bidding {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem 1rem 0.5rem;

    &__price-data {
        ::v-deep {
            .bidding-price-data__total-value {
                font-size: 30px;
                font-weight: 700;
            }
        }
    }

    &__variant-data {
        margin-top: -1rem;
    }

    &__controls {
        margin-top: -0.5rem;
    }

    &__submit-button {
        max-width: 350px;
        margin-inline: auto;
    }

    @include mixins.mobile-only {
        & {
            margin-bottom: 5rem;
            padding: 0;
        }

        &__submit-wrapper {
            position: fixed;
            background-color: var(--white);
            inset: 0;
            top: auto;
            padding: 0.625rem 1rem;
            z-index: 100;
            box-shadow: 0px -1px 5px 3px hsla(0, 0%, 0%, 0.1);
        }

        &__submit-button {
            max-width: 250px;
        }
    }
}
</style>
